<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <el-card>
          <div class="publish-btn" v-if="nextStep === 0" @click="createFn"><i class="el-icon-s-promotion"></i> 新赛季启动</div>

          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">2025～2026 第十赛季</span>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="6" v-for="(item, i) in list" :key="i">
              <div class="camp-item">
                <img src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" class="logo" alt="">
                <div class="bar2"></div>
                <div class="panel panel2">
                  <div class="name">{{ item.productName }}</div>
                  <div class="enName">{{ item.enName }}</div>
                  <div class="date">{{ item.description }}</div>
                  <div class="price">{{ item.price }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <template v-if="expand">
            <el-row class="title_row">
              <el-col :span="12">
                <span class="title_class">2024～2025 第九赛季</span>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="6" v-for="(item, i) in list" :key="i">
                <div class="camp-item">
                  <img src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" class="logo" alt="">
                  <div class="bar2"></div>
                  <div class="panel panel2">
                    <div class="name">{{ item.productName }}</div>
                    <div class="enName">{{ item.enName }}</div>
                    <!-- <div class="date">{{ item.description }}</div> -->
                    <div class="price">{{ item.price }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row class="title_row">
              <el-col :span="12">
                <span class="title_class">2023～2024 第八赛季</span>
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="6" v-for="(item, i) in list" :key="i">
                <div class="camp-item">
                  <img src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" class="logo" alt="">
                  <div class="bar2"></div>
                  <div class="panel panel2">
                    <div class="name">{{ item.productName }}</div>
                    <div class="enName">{{ item.enName }}</div>
                    <!-- <div class="date">{{ item.description }}</div> -->
                    <div class="price">{{ item.price }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </template>
          <div class="bottom-btn" v-if="!expand" @click="expand = true">查看历史赛季信息 <i class="el-icon-caret-bottom"></i></div>
          <div class="bottom-btn" v-if="expand" @click="expand = false">折叠历史赛季信息 <i class="el-icon-caret-top"></i></div>
        </el-card>
      </el-col>
    </el-row>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">审核进度</span>
        </el-col>
      </el-row>
      <el-table :data="auditList" style="margin-top: 15px">
        <el-table-column prop="productName" label="产品名称" align="center"></el-table-column>
        <el-table-column label="审批等级" align="center">一级部门</el-table-column>
        <el-table-column label="审批意见" align="center">同意</el-table-column>
        <el-table-column prop="creator" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请日期" align="center"></el-table-column>
        <el-table-column prop="createTime" label="更新日期" align="center"></el-table-column>
        <el-table-column prop="auditStatus" label="审批状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.auditStatus === 0" type="warning" size="small">待审核</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 1" type="success" size="small">通过</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 2" type="danger" size="small">拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template>
            <el-button type="text" size="mini">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Components',
  data () {
    return {
      nextStep: 0,
      expand: false,
      list: [
        {
          productName: '团队注册',
          enName: 'National Finals',
          description: '2026/05 杭州',
          price: '¥480'
        },
        {
          productName: '全国总决选',
          enName: 'National Finals',
          description: '2026/05 杭州',
          price: '¥4980'
        }
      ],
      list2: [],
      auditList: [
        { productName: '2026～2027赛季ITSO团体赛', creator: '张三', createTime: '2026-06-01', auditStatus: 0 }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.publish-btn{
  background: linear-gradient(140deg, #fcd6b3, #fff);
  color: #F67800;
  width: 100%;
  height: 72px;
  margin: 10px auto 40px;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  line-height: 72px;
  border-radius: 6px;
  cursor: pointer;
  &:hover{
    box-shadow: 0 0 10px rgba(252, 214, 179, .5);
  }
}
.camp-item{
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    margin-bottom: 15px;
    .logo{
      position: absolute;
      right: 10px;
      bottom: 10px;
      height: 60px;
      width: auto;
      // opacity: .8;
    }
    &:hover{
      box-shadow: 0 4px 12px 0 rgba(0,0,0,.4);
    }
    .bar{
      width: 100%;
      height: 6px;
      background-color: #0B177C;
      border-radius: 10px 10px 0 0;
    }
    .bar2{
      width: 100%;
      height: 6px;
      background-color: #F67800;
      border-radius: 10px 10px 0 0;
    }
    .panel{
      padding: 10px 12px;
      border-radius: 0 0 10px 10px;
      .name{
        color: #000;
        font-size: 18px;
        font-weight: bold;
      }
      .enName{
        color: #000;
        font-size: 11px;
        font-weight: bold;
      }
      .flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #969696;
        font-size: 12px;
      }
      .date{
        color: #666;
        font-size: 12px;
        margin-top: 8px;
        height: 30px;
      }
      .price{
        font-weight: bold;
        font-size: 20px;
        color: rgb(234, 31, 31);
        margin-top: 10px;
      }
      &.panel1{
        background: linear-gradient(140deg, #97a1fb 0%, #fff 70%, #fff 100%);
      }
      &.panel2{
        background: linear-gradient(140deg, #fddcbe 0%, #fff 70%, #fff 100%);
      }
    }
  }
  .paper-card2{
  cursor: pointer;
  height: 240px;
  width: 100%;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 12px 0px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
  }
  font-size: 16px;
  color: #79BBFF;
}
.bottom-btn{
  width: 200px;
  margin: 40px auto 0;
  font-size: 14px;
  color: #4096ff;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  i{
    font-size: 20px;
  }
  &:hover{
    text-decoration: underline;
  }
}
</style>
